import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';
import { normalizeData } from '../Schemas';
import { toggleModal } from './ModalActions';

const { GET_TYPES, TYPES_LOADING, ADD_TYPE, ADD_TYPE_FAIL, DELETE_TYPE, UPDATE_TYPE, UPDATE_TYPE_FAIL, RESET_TYPES_ALERT } = Constants;

export const getTypes = (token, newQuery = {}, append = true) => async (dispatch, getState) => {
    
    let query = { page: 1, per_page:15 };

    if(newQuery !== false){
        query = append ? { ...getState().typeStore.query, ...newQuery } : newQuery;
    }

    dispatch(typeLoading());

    const response = await Helpers.makeRequest(token,"TYPES","GET","",query);

    if(response.result){
        const normalizedData = normalizeData(response.data,"types");
        dispatch({ type: GET_TYPES, payload: { data: normalizedData, query: query } });
        dispatch({ type: RESET_TYPES_ALERT, payload: true });
    }
}

export const resetAlert = () => (dispatch) => {
    dispatch({ type: RESET_TYPES_ALERT, payload: true });
}

export const typeLoading = () => ({ type: TYPES_LOADING, payload: true });


export const deleteType = (token,id) => async (dispatch) => {

    const response = await Helpers.makeRequest(token,'TYPES','DELETE','','',id);
    if(response.result){
        dispatch({ type: DELETE_TYPE, payload: id });
    }
}

export const addType = (token,data,permissions) => async (dispatch) => {
    let formData = { name: data.name };    
    const response = await Helpers.makeRequest(token,'TYPES','POST',formData);

    if(response.result){
        //dispatching action ADD_TYPE causes the previous types state to refresh
        dispatch({ type: ADD_TYPE, payload: true });
        dispatch(toggleModal("types","add"));
        //getting types again. Doing this on purpose
        dispatch(getTypes(token));
    }else{
        dispatch({ type: ADD_TYPE_FAIL, payload: response.data });
    }
}

export const editType = (token, data, permissions, id) => async (dispatch) => {
    let formData = { name: data.name };
    const response = await Helpers.makeRequest(token,'TYPES','PUT',formData,'',id);
    if(response.result){
        dispatch({ type: UPDATE_TYPE, payload: response.data.type });
        dispatch(toggleModal("types","edit"));
        dispatch(resetAlert());
    }else{
        dispatch({ type: UPDATE_TYPE_FAIL, payload: response.data });
    }
}


// WEBPACK FOOTER //
// ./src/Actions/TypeActions.js